<div class="d-flex justify-content-between">
  <div class="notification-container" matSnackBarLabel>
    <mat-icon color="{{icon}}" class="{{icon}}">{{ icon }}</mat-icon> 
    <span class="message">{{ message }}</span>
  </div>
  <div matSnackBarActions>
    <mat-icon (click)="snackBarRef.dismissWithAction()" matSnackBarAction>close</mat-icon>
  </div>
</div>